import { z } from "zod";
import { ORG_MEMBER_ROLES, ORG_KINDS } from "@shared/constants/orgRoles.js";

export const ORG_NAME_MAX = 120;
export const ORG_EMAIL_MAX = 254;

export const createOrganizationSchema = z.object({
  name: z
    .string()
    .trim()
    .min(1, "Organization name is required")
    .max(ORG_NAME_MAX, "Name is too long"),
  kind: z.enum(ORG_KINDS).default("hospital"),
});
export type CreateOrganizationInput = z.infer<typeof createOrganizationSchema>;

export const switchOrganizationSchema = z.object({
  // null = switch back to the personal/family context
  organizationId: z.string().uuid("Invalid organization id").nullable(),
});
export type SwitchOrganizationInput = z.infer<typeof switchOrganizationSchema>;

export const addMemberSchema = z.object({
  email: z.string().trim().email("Invalid email address").max(ORG_EMAIL_MAX),
  role: z.enum(ORG_MEMBER_ROLES).default("staff"),
});
export type AddMemberInput = z.infer<typeof addMemberSchema>;

export const updateMemberRoleSchema = z.object({
  role: z.enum(ORG_MEMBER_ROLES),
});
export type UpdateMemberRoleInput = z.infer<typeof updateMemberRoleSchema>;
